const COOKIE_NAME = (process.env.REACT_APP_COOKIE_PREFIX || '') + 'accountData';

export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    return null;
}

function getCookieData() {
    const cookieValue = getCookie(COOKIE_NAME);
    if (!cookieValue) {
        return null;
    }
    try {
        const bytes = Uint8Array.from(atob(cookieValue), c => c.charCodeAt(0));
        return JSON.parse(new TextDecoder().decode(bytes));
    } catch (e) {
        return null;
    }
}

export function getSessionCompany() {
    const data = getCookieData();
    return data?.Company || null;
}

export function getSessionName() {
    const data = getCookieData();
    return data?.Name || null;
}

export function getSessionUser() {
    const data = getCookieData();
    return data?.User || null;
}

export function getSessionManagingCompany() {
    const data = getCookieData();
    return data?.ManagingCompany || null;
}

export function getSessionManagingName() {
    const data = getCookieData();
    return data?.ManagingName || null;
}

export function getSessionIsManagedByPartner() {
    const data = getCookieData();
    return data?.IsManagedByPartner || false;
}
